import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CoreActionLoadMenu,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard,
  selectorCoreMenu
} from '@bepatient/core';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';

@Injectable()
export class MenuGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorCoreMenu, new CoreActionLoadMenu());
  }
}

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.MENU,
  i18nLabel: 'MODULES.MENU',
  icon: 'menu',
  leftMenuAvailableForPages: [0],
  routes: [
    {
      path: 'menu',
      loadChildren: () =>
        import('./pages/menu/menu.module').then(m => m.MenuPageModule),
      canActivate: [MenuGuard]
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    MenuGuard,
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './menu/i18n/', multi: true }
  ],
  declarations: [],
  exports: []
})
export class MenuModule {}
